export default __webpack_public_path__ + "static/media/placeholder_store01-it-mobile.552b7184.png";